import { apiRequest } from '@/lib/api-client';

type SiteSetting = {
  key: string;
  value: any;
  updated_at: string;
};

type NewSiteSetting = {
  key: string;
  value: any;
};

export async function getAllSettings(): Promise<SiteSetting[]> {
  return apiRequest<SiteSetting[]>('/settings/index.php');
}

export async function getSettingByKey(key: string): Promise<SiteSetting | null> {
  const settings = await getAllSettings();
  return settings.find(s => s.key === key) || null;
}

export async function setSetting(key: string, value: any): Promise<SiteSetting> {
  return apiRequest<SiteSetting>('/settings/index.php', {
    method: 'POST',
    body: JSON.stringify({ key, value }),
  });
}

export async function updateSetting(data: { key: string; value: any }): Promise<SiteSetting> {
  return setSetting(data.key, data.value);
}

export async function deleteSetting(key: string): Promise<void> {
  // Not implemented in PHP backend yet
  throw new Error('Delete setting not implemented');
}

export async function uploadImage(data: { fileName: string; base64Data: string }): Promise<{ url: string }> {
  try {
    const response = await apiRequest<{ url: string }>('/settings/upload.php', {
      method: 'POST',
      body: JSON.stringify(data),
    });
    return response;
  } catch (err: any) {
    console.error('Failed to upload image:', err);
    throw new Error(err.message ?? 'Image upload failed');
  }
}

// Alias for compatibility with old naming
export async function getSettings(): Promise<SiteSetting[]> {
  return getAllSettings();
}
